import { Formik } from 'formik'
import React from 'react'

import { useDashboardFeatureFlags } from '@components'
import { LeavingGuard } from '@components/utils/LeavingGuard'
import { HeadContent, SaveShortcutListener } from '@fourthwall/components'
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar'

import type { FormValues } from './Domain.types'
import { validationSchema } from './consts'
import { useDomain } from './hooks/useDomain'
import { ClaimDomain } from './modules/ClaimDomain'
import { CustomDomain } from './modules/CustomDomain'
import { InternalDomain } from './modules/InternalDomain'

export const Domain = () => {
  const { initialValues, handleSubmit } = useDomain()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  return (
    <>
      <HeadContent title="Domain &ndash; Settings" />
      <Formik<FormValues>
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({ dirty, isValid, isSubmitting, submitForm, resetForm }) => (
          <>
            <CustomDomain />

            {dashboardFeatureFlags.subscriptions.enabled && <ClaimDomain />}

            <InternalDomain />

            <SaveShortcutListener disabled={!dirty} onSave={submitForm} />
            <ConfirmBar
              isOpen={dirty}
              isLoading={isSubmitting}
              onConfirm={submitForm}
              onCancel={resetForm}
            />
            <LeavingGuard when={dirty} isValid={isValid} onSave={submitForm} />
          </>
        )}
      </Formik>
    </>
  )
}
